<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>

<script>
// HTTPS is enforced server-side (config.force_ssl in config/environments/
// production.rb), not here. This component used to redirect to https:// from
// mounted() whenever a production-flavored bundle loaded over http, which was
// wrong on two counts: by the time Vue mounts the insecure request has already
// completed and any cookies have already travelled, so it protected nothing;
// and because the flag was baked in at build time, the same bundle could not
// run over http anywhere -- it broke local containers and any environment
// without a certificate.
export default {
  components: {},
};
</script>

<style>
/* The three faces artaround.org actually renders, measured in the browser
   rather than read out of its theme CSS -- the two disagree.

   Open Sans does the work: body, links, labels, buttons (~69 elements on the
   home page). Roboto Condensed 700 is the display face, on every h1/h3/h4.
   Martel appears four times in total -- the wordmark and a couple of editorial
   pull-quotes -- so it is loaded but reserved, not a heading font.

   Only Open Sans is applied here. Roboto Condensed is reachable as Tailwind's
   font-display and Martel as font-serif; both have different metrics, so
   turning either on globally would reflow headings. Opt in per component.

   Roboto (the previous import) is used nowhere on the marketing site. */
@import url("https://fonts.googleapis.com/css2?family=Martel:wght@200;700;900&family=Open+Sans:wght@300;400;600;700&family=Roboto+Condensed:wght@700&display=swap");

body {
  font-family: "Open Sans", "Helvetica", arial, sans-serif;
}

[v-cloak] {
  display: none;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 40px auto;
  font-size: 5px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #fe0205;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.error {
  text-align: center;
  margin-top: 100px;
  font-size: 2rem;
  font-weight: bold;
  color: #fe0205;
}

.style-chooser .vs__dropdown-toggle {
  border: none;
  text-transform: lowercase;
  font-variant: small-caps;
  min-height: 60px;
  font-size: 1.2rem;
  width: 105%;
  margin-bottom: 10px;
  outline: none;
  border-radius: 5px;
}

.style-chooser .vs__search::placeholder {
  padding-left: 10px;
  color: #7d7d7d;
}

.style-chooser .vs__dropdown-toggle {
  border: 1px solid #eee;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.style-chooser .vs__dropdown-menu {
  display: none;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
</style>
